import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import strings from '../../../../../localization';
import styles from './styles';

interface IContractDeleteMessage {
  totalShiftCount: number;
}

const ContractDeleteMessage: FC<IContractDeleteMessage> = ({
  totalShiftCount,
}) =>
  (
    <Box>
      <Typography sx={styles.deleteMessage}>
        {strings.formatString(
          strings.onlyPostedShiftsDeleteNote,
          totalShiftCount,
        )}
      </Typography>
      <Box sx={styles.noteContainer}>
        <Typography sx={styles.noteText}>{strings.note}</Typography>
        <Typography sx={styles.noteDescription}>
          {strings.bookedShiftsWillNotBeDeleted}
        </Typography>
      </Box>
    </Box>
  );

export default ContractDeleteMessage;
